import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../../../utils/axiosConfig';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Redirect } from 'react-router-dom';
import { useParams } from 'react-router';
import { Avatar, Box, Button, Card, CardActions, CardActionArea, CardHeader, CardContent, Divider, Grid, IconButton, Menu, MenuItem, Paper, TextField, Typography } from '@material-ui/core';
import ResponsiveLayout from '../../../../Layouts/ResponsiveLayout';
import { StateContext, DispatchContext } from '../../../../../context/Provider';
import CommentItem from './CommentItem/CommentItem';
import PostCommentForm from './PostCommentForm/PostCommentForm';
import GradingForm from './GradingForm/GradingForm';

const Comments = (props) => {

  const { classcode, classwork_id, student_id } = useParams();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const { authState } = appState;
  const { globalDispatch } = appDispatch;

  const [classwork, setClasswork] = useState(null);
  const [student, setStudent] = useState(null);
  const [classworkGradeInfo, setClassworkGradeInfo] = useState(null);
  const [commentsArr, setCommentsArr] = useState([]);

  const useStyles = makeStyles((theme) => ({
    root: {
      // minWidth: 345
    },
    cardHeader: {
      // paddingBottom: '35px',
      // backgroundColor: props.themeColor ? props.themeColor : "#ff5722",
      // color: '#fff'
    },
    cartTitle: {
      fontWeight: 500,
      marginBottom: 0
    },
    subHeader: {
      // color: '#fff'
    },
    moreVertIcon: {
      // color: '#fff'
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    medium: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    root1: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    input1: {
      borderRadius: '12px',
      paddingTop: '3px',
      paddingBottom: '3px',
      paddingLeft: '15px',
      background: "rgb(0, 0, 0, 0.05)",
      border: '2px',
      marginLeft: theme.spacing(1),
      flex: 1
    },
    iconButton1: {
      padding: 10,
      "&:hover": {
        backgroundColor: "#fff"
      }
    },
    divider1: {
      height: 28,
      margin: 4,
    },
    verticalScroll: {
      maxHeight: '350px',
      overflowY: 'auto'
    }
  }));

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  async function fetchClassworkSubmissions() {
    try {
      const response = await axiosConfig.get(`/classworkSubmissions/${classwork_id}`); 
      const { data } = response.data;
      setClasswork(data);
    } catch(e) {
      console.log(e);
    }

    globalDispatch({type: 'setIsLoading', value: false});
  }

  async function fetchStudentInfo() {
    try {
      const response = await axiosConfig.get(`/students/${student_id}`); 
      const { data } = response.data;
      setStudent(data);
    } catch(e) {
      console.log(e);
    }

    globalDispatch({type: 'setIsLoading', value: false});
  }

  async function fetchStudentGrades() {
    try {
      const response = await axiosConfig.get(`/fetchStudentGrades/${student_id}/${classwork_id}`);
      const { data } = response.data;
      setClassworkGradeInfo(data.classworkGrade);

    } catch(e) {
      console.log(e);
    }
  }

  async function fetchComments() {
    try {
      const response = await axiosConfig.get(`/classworkSubmissionComments?classwork_id=${classwork_id}&student_id=${student_id}`);
      const { comments } = response.data.data;
      setCommentsArr(comments);
    } catch(e) {
      console.log(e);
    }

    globalDispatch({type: 'setIsLoading', value: false});
  }

  useEffect(() => {

    if(!classcode) {
      <Redirect to="/dashboard" />;
    }

    globalDispatch({type: 'setIsLoading', value: true});
    globalDispatch({type: 'setTabValue', value: 1});
    globalDispatch({type: 'setShowTabs', value: true});

    const source = axiosConfig.CancelToken.source();
    fetchClassworkSubmissions();
    fetchStudentInfo();
    fetchStudentGrades();
    fetchComments();

    return () => {
      source.cancel();
    }

  }, []);

  return (
    <ResponsiveLayout classcode={classcode}>
      <Box mt={2} />

      { classwork && classworkGradeInfo ? (
        <Grid
          container
          spacing={2}
        >
          <Grid item xs={12} sm={12}>
            
            <Button
              variant="outlined"
              color="primary"
              size="small"
              component={Link}
              to={ 
                authState.user.role_id == 5 
                  ? `/${classcode}/classwork/${classwork_id}`
                  : `/${classcode}/classworkSubmissions/${classwork_id}`
              }
            >
              Back
            </Button>

            <Box mt={2} />
            <Typography variant="h6">
              {`${classwork.title} ${classwork.is_graded ? ' - Graded' : ''} (${classwork.work_type})`} | Due date: {classwork.due_date || 'N/A'}
            </Typography>
            <Typography>
              {classwork.description}
            </Typography>
            <Box mt={2} />
            
            <Typography>Attachment/s:</Typography>
            { classwork.attachments ? (
              <Box style={{marginLeft: -5}}>
                <Button
                  size="small" 
                  color="primary" 
                  href={classwork.attachments_url || ''}
                  target="_blank"
                  download
                >
                  { classwork.attachments || ''}
                </Button>
              </Box>) : '' 
            }

            {classwork.files && classwork.files.map((file, i) => (
              <Box style={{marginLeft: -5}} key={i}>
                <Button
                  size="small" 
                  color="primary" 
                  href={file.file_url || ''}
                  target="_blank"
                  download
                >
                  { file.file_name || ''}
                </Button>
              </Box>
            ))}

            { !classwork.attachments && !classwork.files ? (
              'No attachment/s available'
            ) : ''}

            <Box mt={2} />
            <Typography>Assigned To: <b>{student ? student.name : null}</b></Typography>
            <Box mt={1} />

            <Typography>Student submission/s:</Typography>
            {classwork.students && classwork.students.map((student, a) => {
              if (student.id == student_id) {
                return (
                  <Box key={a}>
                    {student.attachmentsArr.length > 0 && student.attachmentsArr.map((attachment, b) => (
                      <Box style={{marginLeft: -5}} key={b}>
                        <Button
                          size="small" 
                          color="primary" 
                          href={attachment.attachment_url || ''}
                          target="_blank"
                          download
                        >
                          { attachment.attached_file || ''}
                        </Button>
                      </Box>
                    ))}

                    {!student.attachmentsArr.length > 0 ? (
                      'No student submission/s available'
                    ) : ''}
                  </Box>
                );
              }
            })}

            <Box mt={1} />

          </Grid>
          
          {/* not visible for students */}
          { authState.user.role_id !== 5 && (
              <GradingForm 
                classwork={classwork}
                classworkGradeInfo={classworkGradeInfo}
              />
            )
          }

          <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
            <Card>
              <CardHeader 
                className={classes.cardHeader}
                title={
                  <Typography className={classes.cartTitle} gutterBottom variant="body1" component="h2">
                    Submission Comments
                  </Typography>
                }
              />

              <CardContent
                className={classes.verticalScroll}
                style={{minHeight: '5px', paddingTop: 0}}
              >
                {commentsArr.map((comment, i) => (
                  <CommentItem 
                    key={i}
                    comment={comment}
                  />
                ))}

                { commentsArr.length === 0 ? 'No comment/s found.' : null }
              </CardContent>

              <Divider />

              <PostCommentForm
                classes={classes}
                classworkID={classwork_id}
                studentID={student_id}
                fetchComments={fetchComments}
              />

            </Card>
          </Grid>
        </Grid>
      ) : null }

    </ResponsiveLayout>
  );

}

export default Comments;